import { makeStyles } from "@material-ui/core";
import theme from "tools/theme";

export default makeStyles(({ spacing }) => ({
  root: {
    padding: spacing(3, 3, 2, 3),
    width: "480px",
  },
  header: {
    fontSize: 24,
    lineHeight: 1.5,
    marginBottom: theme.spacing(3),
  },

  alert: {
    marginBottom: theme.spacing(3),
  },
}));
